<template>
  <v-dialog v-model="openComputed" max-width="550" persistent>
    <v-card>
      <v-card-title class="headline colorHeadlineDelete" primary-title>{{ header }}</v-card-title>
      <v-card-text>
        <h2 class="mt-4">{{ body }}</h2>
      </v-card-text>
      <v-card-actions>
        <v-btn color="colorDelete" @click="($emit('confirm', true), $emit('update:openDialog', false))">{{ $t('btn.delete') }}</v-btn>
        <v-spacer />
        <v-btn color="colorCancel" @click="$emit('update:openDialog', false)">{{ $t('btn.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'deleteDialog',
  props: {
    header: String,
    body: String,
    openDialog: Boolean,
  },
  computed: {
    // v-model cannot use openDialog because it is immutable
    openComputed(): boolean {
      return this.openDialog;
    },
  },
});
</script>
